import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { distinctUntilChanged, filter, map } from 'rxjs';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

// EXT-6071 (follow-up to EXT-5255 in jfw-platform-portal): GTM's GA4
// Configuration tag's automatic history-change page_view listener can race
// against Angular's title update and capture the generic app title instead
// of the page-specific one. Firing an explicit dataLayer page_view here,
// from NavigationEnd, reads Title.getTitle() at a point Angular guarantees
// is after SEOResolver has already set it for the resolved route.
@Injectable({ providedIn: 'root' })
export class PageViewTrackingService {
  private router = inject(Router);
  private titleService = inject(Title);

  constructor() {
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd,
        ),
        map((event) => event.urlAfterRedirects),
        distinctUntilChanged(),
      )
      .subscribe((urlAfterRedirects) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'page_view',
          page_title: this.titleService.getTitle(),
          page_path: urlAfterRedirects,
          page_location: window.location.href,
        });
      });
  }
}
